/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Highlight_Settings_Opacity_NoteInputs */

const en_highlight_settings_opacity_note = /** @type {(inputs: Highlight_Settings_Opacity_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note: Opacity is applied automatically in highlights`)
};

const es_highlight_settings_opacity_note = /** @type {(inputs: Highlight_Settings_Opacity_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota: la opacidad se aplica automáticamente`)
};

/**
* | output |
* | --- |
* | "Note: Opacity is applied automatically in highlights" |
*
* @param {Highlight_Settings_Opacity_NoteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const highlight_settings_opacity_note = /** @type {((inputs?: Highlight_Settings_Opacity_NoteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Highlight_Settings_Opacity_NoteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_highlight_settings_opacity_note(inputs)
	return en_highlight_settings_opacity_note(inputs)
});